(function () {
  'use strict';
  if (window.__sarahCharmBuilderLoaded) return;
  window.__sarahCharmBuilderLoaded = true;

  var launchers = new Map();
  function placeLaunchers() {
    launchers.forEach(function (state, root) {
      if (!root.isConnected) { if (state.clone) state.clone.remove(); launchers.delete(root); return; }
      var form = findProductForm(root);
      var info = form && form.closest('.product-info');
      var target = info && info.querySelector('[data-block-type="buy-buttons"]');
      if (!target) { if (state.clone) state.clone.remove(); state.original.hidden = false; return; }
      if (!state.clone || !state.clone.isConnected || state.clone.parentElement !== target.parentElement) {
        if (state.clone) state.clone.remove();
        state.clone = state.original.cloneNode(true);
        state.clone.hidden = false;
        state.clone.addEventListener('click', state.open);
        target.before(state.clone);
      }
      state.original.hidden = true;
    });
  }
  function findProductForm(root) {
    var productId = root.dataset.productId;
    if (!productId) return null;
    return Array.from(document.querySelectorAll('form[id]')).find(function (form) {
      var formId = form.getAttribute('id') || '';
      return formId.startsWith('product-form-main-' + productId + '-') && !formId.endsWith('-payment-installment');
    }) || null;
  }
  function initAll() {
    document.querySelectorAll('[data-ccb]').forEach(initInstance);
  }

  // --- Rimozione automatica dello sfondo bianco dei charm (fallback via canvas) ---
  // Rende trasparenti i pixel quasi-bianchi di un'immagine. Non sostituisce foto
  // già ritagliate professionalmente, ma evita il "quadratino bianco" quando le foto
  // dei charm arrivano su sfondo bianco pieno. Se l'immagine non è servita con CORS
  // (raro per il CDN Shopify) fallisce in silenzio e usa l'originale.
  var __cleanImgCache = new Map();
  function stripWhiteBackground(src, callback) {
    if (!src) { callback(src); return; }
    if (__cleanImgCache.has(src)) { callback(__cleanImgCache.get(src)); return; }

    var img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = function () {
      try {
        var canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var px = imageData.data;

        // Sfumatura invece di soglia netta: i pixel sotto minWhite restano opachi,
        // sopra maxWhite diventano completamente trasparenti, in mezzo l'alpha
        // scende gradualmente. Riduce l'alone chiaro sui bordi delle foto con
        // ombre morbide (tipico delle foto prodotto), rispetto a un taglio netto.
        var minWhite = 230;
        var maxWhite = 250;

        for (var i = 0; i < px.length; i += 4) {
          var whiteness = Math.min(px[i], px[i + 1], px[i + 2]);
          if (whiteness >= maxWhite) {
            px[i + 3] = 0;
          } else if (whiteness > minWhite) {
            var fade = (whiteness - minWhite) / (maxWhite - minWhite);
            px[i + 3] = Math.round(px[i + 3] * (1 - fade));
          }
        }

        ctx.putImageData(imageData, 0, 0);
        var dataUrl = canvas.toDataURL('image/png');
        __cleanImgCache.set(src, dataUrl);
        callback(dataUrl);
      } catch (e) {
        // canvas "tainted": quasi sempre un blocco CORS sul CDN che serve l'immagine.
        // Non blocchiamo nulla: si usa l'originale, ma lo segnaliamo in console così
        // è possibile capire subito perché lo sfondo non viene rimosso.
        console.warn('[ccb] impossibile rimuovere lo sfondo (probabile blocco CORS su questa immagine), uso l\'originale:', src, e);
        __cleanImgCache.set(src, src);
        callback(src);
      }
    };
    img.onerror = function () {
      console.warn('[ccb] immagine charm non caricata per la pulizia sfondo:', src);
      __cleanImgCache.set(src, src);
      callback(src);
    };
    img.src = src;
  }

  function initInstance(root) {
    if (root.__ccbInit) return;
    root.__ccbInit = true;

    var trackEl = root.querySelector('[data-ccb-track]');
    var totalEl = root.querySelector('[data-ccb-total]');
    var messageEl = root.querySelector('[data-ccb-message]');
    var addToCartBtn = root.querySelector('[data-ccb-add-to-cart]');
    var clearBtn = root.querySelector('[data-ccb-clear]');
    var photoOverlayEl = root.querySelector('[data-ccb-photo-overlay]');
    var paletteGroups = root.querySelectorAll('[data-ccb-palette]');

    var braceletVariantId = root.getAttribute('data-bracelet-variant-id');
    var braceletPrice = parseInt(root.getAttribute('data-bracelet-price'), 10) || 0;
    var maxCharms = parseInt(root.getAttribute('data-max-charms'), 10) || 8;
    var stripBg = root.getAttribute('data-strip-white-bg') === 'true';

    var charmScale = parseFloat(root.getAttribute('data-charm-scale'));
    root.style.setProperty('--ccb-charm-scale', (charmScale || 18) + '%');

    var anchors = {
      p0: { x: Number(root.getAttribute('data-anchor-start-x')), y: Number(root.getAttribute('data-anchor-start-y')) },
      p1: { x: Number(root.getAttribute('data-anchor-mid-x')), y: Number(root.getAttribute('data-anchor-mid-y')) },
      p2: { x: Number(root.getAttribute('data-anchor-end-x')), y: Number(root.getAttribute('data-anchor-end-y')) }
    };

    // stato: array ordinato di { uid, variantId, price, title, image }
    var composition = [];
    var busy = false;
    var baseSelect = root.querySelector('[data-ccb-base]');
    var photo = root.querySelector('.ccb__photo');

    function uid() {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
      return 'ccb-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat(root.dataset.locale || 'it', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(cents / 100);
    }

    // --- Charm compatibili per prodotto: mostra solo il gruppo <ul> della base scelta ---

    function showPaletteForProduct(productId) {
      paletteGroups.forEach(function (ul) {
        ul.hidden = ul.getAttribute('data-for-base') !== String(productId);
      });
    }

    function syncBase() {
      var option = baseSelect.options[baseSelect.selectedIndex];
      braceletVariantId = option ? option.value : '';
      braceletPrice = option ? Number(option.dataset.price) : 0;
      addToCartBtn.disabled = busy || !option || option.dataset.available !== 'true';
      if (photo && option) {
        if (option.dataset.image) photo.src = option.dataset.image;
        photo.parentElement.hidden = !option.dataset.image;
        photo.alt = option.textContent.trim();
        photo.removeAttribute('width');
        photo.removeAttribute('height');
      }
      if (option) showPaletteForProduct(option.dataset.productId);
      renderTotal();
    }
    baseSelect.addEventListener('change', syncBase);

    var dialog = root.querySelector('dialog');
    var opener = root.querySelector('[data-ccb-open]');
    if (dialog && opener) {
      var returnFocus = null;
      var lastNativeVariant = null;
      function openConfigurator(event) {
        returnFocus = event.currentTarget;
        var form = findProductForm(root);
        var variantField = form && form.elements.namedItem('id');
        var nativeId = variantField && variantField.value;
        if (nativeId && nativeId !== lastNativeVariant && Array.from(baseSelect.options).some(function (option) { return option.value === nativeId; })) {
          baseSelect.value = nativeId; syncBase(); lastNativeVariant = nativeId;
        }
        if (!dialog.open) dialog.showModal();
      }
      opener.addEventListener('click', openConfigurator);
      root.querySelector('[data-ccb-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', function () { if (returnFocus && returnFocus.isConnected) returnFocus.focus(); });
      launchers.set(root, { original: opener, clone: null, open: openConfigurator });
      placeLaunchers();
    }

    function showMessage(text) {
      messageEl.textContent = text || '';
    }

    function calcTotal() {
      var total = braceletPrice;
      composition.forEach(function (c) { total += c.price; });
      return total;
    }

    function renderTotal() {
      totalEl.textContent = formatMoney(calcTotal());
    }

    // --- Anteprima fotorealistica: posiziona i charm lungo una curva di Bézier ---
    // calibrata dai 3 punti (data-anchor-*), spaziati in modo uniforme per lunghezza
    // d'arco (non per parametro t), così restano ben distanziati anche su curve marcate.

    function bezierPoint(t, p0, p1, p2) {
      var mt = 1 - t;
      return {
        x: mt * mt * p0.x + 2 * mt * t * p1.x + t * t * p2.x,
        y: mt * mt * p0.y + 2 * mt * t * p1.y + t * t * p2.y
      };
    }

    function evenlySpacedPoints(p0, p1, p2, n) {
      if (n <= 0) return [];
      if (n === 1) return [bezierPoint(0.5, p0, p1, p2)];

      var samples = 100;
      var pts = [bezierPoint(0, p0, p1, p2)];
      var cum = [0];

      for (var i = 1; i <= samples; i++) {
        var pt = bezierPoint(i / samples, p0, p1, p2);
        var prev = pts[i - 1];
        cum.push(cum[i - 1] + Math.hypot(pt.x - prev.x, pt.y - prev.y));
        pts.push(pt);
      }

      var totalLen = cum[cum.length - 1];
      var result = [];

      for (var k = 0; k < n; k++) {
        var targetLen = (k / (n - 1)) * totalLen;
        var idx = 0;
        while (idx < cum.length - 1 && cum[idx + 1] < targetLen) idx++;
        var segStart = cum[idx];
        var segEnd = cum[idx + 1] !== undefined ? cum[idx + 1] : segStart;
        var segT = segEnd > segStart ? (targetLen - segStart) / (segEnd - segStart) : 0;
        var a = pts[idx];
        var b = pts[idx + 1] !== undefined ? pts[idx + 1] : a;
        result.push({ x: a.x + (b.x - a.x) * segT, y: a.y + (b.y - a.y) * segT });
      }

      return result;
    }

    function renderPhoto() {
      if (!photoOverlayEl) return;
      photoOverlayEl.innerHTML = '';

      var points = evenlySpacedPoints(anchors.p0, anchors.p1, anchors.p2, composition.length);

      composition.forEach(function (charm, i) {
        if (!charm.image) return;
        var point = points[i];
        var span = document.createElement('span');
        span.className = 'ccb__photo-charm';
        span.style.left = point.x + '%';
        span.style.top = point.y + '%';

        var img = document.createElement('img');
        img.src = charm.image;
        img.alt = charm.title;
        span.appendChild(img);

        photoOverlayEl.appendChild(span);
      });
    }

    function renderTrack() {
      trackEl.innerHTML = '';

      for (var i = 0; i < maxCharms; i++) {
        var charm = composition[i];
        var li = document.createElement('li');

        if (charm) {
          li.className = 'ccb__slot ccb__slot--filled';
          li.setAttribute('data-uid', charm.uid);
          li.setAttribute('draggable', 'false');

          var img = document.createElement('img');
          if (charm.image) img.src = charm.image;
          img.alt = charm.title;
          li.appendChild(img);

          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'ccb__slot-remove';
          removeBtn.setAttribute('aria-label', 'Rimuovi ' + charm.title);
          removeBtn.textContent = '×';
          removeBtn.addEventListener('click', function (charmUid) {
            return function (e) {
              e.stopPropagation();
              removeCharm(charmUid);
            };
          }(charm.uid));
          li.appendChild(removeBtn);

          attachDrag(li, charm.uid);
        } else {
          li.className = 'ccb__slot';
        }

        trackEl.appendChild(li);
      }

      renderPhoto();
    }

    function addCharm(charmData) {
      if (busy) return;
      if (composition.length >= maxCharms) {
        showMessage('Hai raggiunto il numero massimo di charm (' + maxCharms + ').');
        return;
      }
      composition.push({
        uid: uid(),
        variantId: charmData.variantId,
        price: charmData.price,
        title: charmData.title,
        image: charmData.image
      });
      showMessage('');
      renderTrack();
      renderTotal();
    }

    function removeCharm(charmUid) {
      if (busy) return;
      composition = composition.filter(function (c) { return c.uid !== charmUid; });
      renderTrack();
      renderTotal();
    }

    function reorderCharm(fromUid, toIndex) {
      if (busy) return;
      var fromIndex = composition.findIndex(function (c) { return c.uid === fromUid; });
      if (fromIndex === -1) return;
      var item = composition.splice(fromIndex, 1)[0];
      composition.splice(toIndex, 0, item);
      renderTrack();
    }

    // --- Palette: click per aggiungere (delegato su tutto root, copre tutti i gruppi) ---

    root.addEventListener('click', function (e) {
      var charmEl = e.target.closest('[data-ccb-charm]');
      if (!charmEl || charmEl.disabled || charmEl.getAttribute('data-available') !== 'true') return;
      addCharm({
        variantId: charmEl.getAttribute('data-variant-id'),
        price: parseInt(charmEl.getAttribute('data-price'), 10) || 0,
        title: charmEl.getAttribute('data-title'),
        image: charmEl.getAttribute('data-image')
      });
    });

    // Pulizia sfondo bianco: una volta sola per ogni charm della palette, all'avvio.
    // Aggiorna sia la miniatura in palette sia l'attributo data-image che addCharm
    // legge al click, così slot e foto ricevono già la versione ripulita.
    if (stripBg) {
      root.querySelectorAll('[data-ccb-charm]').forEach(function (charmEl) {
        var original = charmEl.getAttribute('data-image');
        if (!original) return;
        stripWhiteBackground(original, function (cleanSrc) {
          charmEl.setAttribute('data-image', cleanSrc);
          var img = charmEl.querySelector('img');
          if (img) img.src = cleanSrc;
        });
      });
    }

    // --- Drag & drop per riordinare gli slot già riempiti (Pointer Events) ---

    function attachDrag(slotEl, charmUid) {
      var targetIndex = null, dragging = false;
      slotEl.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button')) return;
        dragging = true; targetIndex = null;
        slotEl.setPointerCapture(e.pointerId);
        slotEl.classList.add('ccb__slot--dragging');
      });
      slotEl.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var best = Infinity;
        trackEl.querySelectorAll('.ccb__slot--filled').forEach(function (el, i) {
          var r = el.getBoundingClientRect(), d = Math.hypot(e.clientX - r.left - r.width / 2, e.clientY - r.top - r.height / 2);
          if (d < best) { best = d; targetIndex = i; }
        });
      });
      slotEl.addEventListener('pointerup', function () {
        dragging = false; slotEl.classList.remove('ccb__slot--dragging');
        if (targetIndex !== null) reorderCharm(charmUid, targetIndex);
      });
      slotEl.addEventListener('pointercancel', function () { dragging = false; slotEl.classList.remove('ccb__slot--dragging'); });
      slotEl.tabIndex = 0;
      slotEl.setAttribute('aria-label', 'Usa le frecce per spostare il charm');
      slotEl.addEventListener('keydown', function (e) {
        if (e.target !== slotEl || ['ArrowLeft', 'ArrowRight'].indexOf(e.key) === -1) return;
        e.preventDefault(); var index = composition.findIndex(function (c) { return c.uid === charmUid; });
        reorderCharm(charmUid, Math.max(0, Math.min(composition.length - 1, index + (e.key === 'ArrowLeft' ? -1 : 1))));
        trackEl.querySelector('[data-uid="' + charmUid + '"]').focus();
      });
    }

    // --- Svuota ---

    clearBtn.addEventListener('click', function () {
      if (busy) return;
      composition = [];
      showMessage('');
      renderTrack();
      renderTotal();
    });

    // --- Aggiungi al carrello ---

    addToCartBtn.addEventListener('click', function () {
      if (busy) return;
      syncBase();
      if (!braceletVariantId || addToCartBtn.disabled) {
        showMessage('Variante del gioiello non disponibile.');
        return;
      }

      busy = true;
      baseSelect.disabled = true;
      addToCartBtn.disabled = true;
      showMessage('');

      var configId = uid();

      var items = [{
        id: braceletVariantId,
        quantity: 1,
        properties: {
          '_config_id': configId,
          'Composizione': composition.map(function (c, i) { return (i + 1) + '. ' + c.title; }).join(' | '),
          '_composition': JSON.stringify(composition.map(function (c) { return { id: c.variantId, title: c.title }; }))
        }
      }];

      composition.forEach(function (c, index) {
        items.push({
          id: c.variantId,
          quantity: 1,
          properties: {
            '_bundle_of': configId,
            '_slot': String(index + 1),
            'Posizione': String(index + 1)
          }
        });
      });

      fetch(root.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || 'Errore aggiunta al carrello.');
            });
          }
          return res.json();
        })
        .then(function () {
          // Adatta questo punto al tuo tema:
          // - se il tema ha un cart drawer con evento custom, sostituisci il redirect
          //   con il trigger di quell'evento (es. document.dispatchEvent(new CustomEvent('cart:refresh')))
          // - altrimenti il redirect al carrello è la via più semplice e universale.
          window.location.href = root.dataset.cartUrl;
        })
        .catch(function (err) {
          showMessage(err.message || 'Errore imprevisto, riprova.');
          busy = false; baseSelect.disabled = false; syncBase();
        });
    });

    // init
    syncBase();
    renderTrack();
    renderTotal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; initAll(); placeLaunchers(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();